<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>
    <div :class="{'has-error':errors.variable}">
      <select name="dataClassification" :value="dataClassification" class="form-control" @change="handleChange">
        <option value="" selected="selected">
          Select Category
        </option>
        <option v-for="(classification, $id) in config.dataClassifications" :value="$id">
          {{ classification }}
        </option>
      </select>
    </div>
  </div>
</template>
<script type="text/javascript">
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';

  export default {
    extends: BaseComponent,

    props: {
      dataClassification: Number,
      id: String
    },
    methods: {
      validate: function() {
        this.errors = {};

        if (!this.dataClassification) {
          this.errors.dataClassification = 'Please select a Classification.';
        }

        return Object.keys(this.errors).length === 0;
      }
    }
  };
</script>
